import React, { useState } from "react";
import "./BankDetails.css";
import CustomDropdown from "../../../../../Components/CustomDropdown/CustomDropdown";
import CustomTimeSelector from "../../../../Components/CustomTimeSelector/CustomTimeSelector";
import CustomTable from "../../../../Components/CustomTable/CustomTable";
import CustomSwitch from "../../../../../Components/CustomSwitch/CustomSwitch";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";

const BankDetails = () => {
  return (
    <div className="cltdetails__bankdetails_page">
      <div className="cltdetails__bankdetails_contentwrap">
        <div className="cltdetails__bankdetails_contentbox">
          <div className="cltdetails__bankdetails_cboxheader">
            Bank Information
          </div>
          <div className="cltdetails__bankdetails_cboxbody">
            <div className="cltdetails__bankdetails_cboxrow">
              <div className="cltdetails__bankdetails_cboxcol">
                <div className="cltdetails__bankdetails_cboxfieldbox">
                  <label className="cltdetails__bankdetails_cboxfieldlbl">
                    Name of the account holder
                  </label>
                  <div className="cltdetails__bankdetails_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__bankdetails_cboxfield"
                      placeholder="Name of the account"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__bankdetails_cboxcol">
                <div className="cltdetails__bankdetails_cboxfieldbox">
                  <label className="cltdetails__bankdetails_cboxfieldlbl">
                    Name of the bank
                  </label>
                  <div className="cltdetails__bankdetails_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__bankdetails_cboxfield"
                      placeholder="Name of the bank"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__bankdetails_cboxcol">
                <div className="cltdetails__bankdetails_cboxfieldbox">
                  <label className="cltdetails__bankdetails_cboxfieldlbl">
                    US bank Routing number (9 digits)
                  </label>
                  <div className="cltdetails__bankdetails_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__bankdetails_cboxfield"
                      placeholder="US Bank Routing Number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="cltdetails__bankdetails_cboxrow">
              <div className="cltdetails__bankdetails_cboxcol">
                <div className="cltdetails__bankdetails_cboxfieldbox">
                  <label className="cltdetails__bankdetails_cboxfieldlbl">
                    US Bank Account Number
                  </label>
                  <div className="cltdetails__bankdetails_cboxfieldwrap">
                    <input
                      type="text"
                      className="cltdetails__bankdetails_cboxfield"
                      placeholder="US Bank Account Number"
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__bankdetails_cboxcol">
                <div className="cltdetails__bankdetails_cboxfieldbox">
                  <label className="cltdetails__bankdetails_cboxfieldlbl">
                    Type Of Account
                  </label>
                  <div className="cltdetails__bankdetails_cboxfieldwrap">
                    <CustomDropdown
                      customStyles={{
                        height: 56,
                        borderColor: "lightgrey",
                        marginTop: 0,
                      }}
                      options={["opt1"]}
                    />
                  </div>
                </div>
              </div>
              <div className="cltdetails__bankdetails_cboxcol"></div>
            </div>
          </div>
        </div>
        <div
          className="cltdetails__bankdetails_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="cltdetails__bankdetails_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="cltdetails__bankdetails_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
        <div className="cltdetails__bankdetails_savebtnwrap">
          <button className="cltdetails__bankdetails_savebtn">Save</button>
        </div>
      </div>
      <div className="cltdetails__bankdetails_contentwrap">
        <div className="cltdetails__bankdetails_bottombtns">
          <button className="cltdetails__bankdetails_bbtnfilled">Submit</button>
          <button className="cltdetails__bankdetails_bbtnoutlined">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default BankDetails;
